// Constants for the Integritas website
export const INTEGRITAS_BASE_DOMAIN = 'integritas.technology';
export const INTEGRITAS_BASE_URL = `https://${INTEGRITAS_BASE_DOMAIN}`;
export const INTEGRITAS_DOCS_DOMAIN = 'docs.integritas.technology';
export const INTEGRITAS_DOCS_URL = `https://${INTEGRITAS_DOCS_DOMAIN}`;
export const INTEGRITAS_DOCS_WEBAPP_GUIDE_URL = `${INTEGRITAS_DOCS_URL}/docs/web-user-guide`;
